
import {downgradeInjectable} from '@angular/upgrade/static';
import {ModalService} from '../public/upgrade/root/modal/modal.service';
import {TranslateService} from '@ngx-translate/core';
import {LoadingWheelService} from '../public/upgrade/root/loading/loading-wheel.service';
import {SessionService} from '../public/upgrade/core/session.service';
import {InformationModalService} from '../public/upgrade/root/information-modal/information-modal.service';

import {SidebarService} from '../public/upgrade/root/sidebar/sidebar.service';
import {NotificationService} from '../public/upgrade/root/toast/notification.service';
import {BackgroundColorService} from '../public/upgrade/root/background-color/background-color.service';

import {CompanyServiceA2} from '../public/upgrade/core/company_a2.service';
import {EmailValidatorService} from '../public/upgrade/core/email-validator.service.ts';

window.App = angular.module('CarsSaraBo', [
    'ngResource',
    'ngRoute',
    'ngCookies',
    'ui.bootstrap',
    'flow',
    'ui.select',
    'pascalprecht.translate',
    'ngSanitize',
    'ngFileUpload',
    'infinite-scroll'
]);

// register NG2 services
angular.module('CarsSaraBo')
    .service('ModalService', downgradeInjectable(ModalService))
    .service('$translate2', downgradeInjectable(TranslateService));
angular.module('CarsSaraBo').factory('CompanyServiceA2', downgradeInjectable(CompanyServiceA2));
angular.module('CarsSaraBo').service('LoadingWheelService', downgradeInjectable(LoadingWheelService));
angular.module('CarsSaraBo').service('SessionService', downgradeInjectable(SessionService));
angular.module('CarsSaraBo').service('SidebarService', downgradeInjectable(SidebarService));
angular.module('CarsSaraBo').service('InformationModalService', downgradeInjectable(InformationModalService));
angular.module('CarsSaraBo').service('NotificationService', downgradeInjectable(NotificationService));
angular.module('CarsSaraBo').service('BackgroundColorService', downgradeInjectable(BackgroundColorService));
angular.module('CarsSaraBo').service('EmailValidatorService', downgradeInjectable(EmailValidatorService));

function ErrProvider() {
    this.$get = ['$log', '$window',
        function($log, $window) {
            return function(exception, cause) {
                // send to new relic
                if ($window.NREUM) {
                    $window.NREUM.noticeError(exception)
                }

                // standard behaviour
                $log.error.apply($log, arguments);
            };

        }];
}

angular.module('app-errors', []).provider('$exceptionHandler', ErrProvider);

export default window.App;



//////////////////
// WEBPACK FOOTER
// ./config/application.js
// module id = 799
// module chunks = 3